const Loading = () => {
    return (
        <div style={{margin:"auto"}}>
            <span className="loader"></span>
        </div>
    );
};
export default Loading;
